var syliusCartSubmittedBy = null;

$(function () {
	//Matchmedia korespondující s mediaquaries pro bootstrap

	if (mqxl.matches) {
		//XL nad 1199px

	} else if (mqlg.matches) {
		//LG nad 991px

	} else if (mqmd.matches) {
		//MD nad 767px

	} else if (mqsm.matches) {
		//SM nad 575px

	} else {
		//XS do 575px

	}

	// Ostatní JS společné pro všechny zařízení
	//----------------------------------------------------------------------

	$("form[name='sylius_cart']").on("submit", function (e) {
		e.preventDefault();

		submitCartForm($(this));
		return false;
	});

	$(document).on("sylius.cart.quantity_changed", function(e, data) {
		var form = $("form[name='sylius_cart']");
		submitCartForm(form);
	});


	$(document).on("click", "#s31-cart-coupon-button", function (e) {
		syliusCartSubmittedBy = "coupon-button";

		$("#s31-cart-coupon-button").parent().removeClass("field error");
		$("#s31-cart-coupon-button").next(".alert").remove();

		if ($("#sylius_cart_promotionCoupon").length > 0) {
			if ($("#sylius_cart_promotionCoupon").is(":disabled")) {
				$("#sylius_cart_promotionCoupon").val("").removeAttr("disabled");
			}
			else if ($.trim($("#sylius_cart_promotionCoupon").val()) == "") {
				e.preventDefault();
				e.stopPropagation();

				$("#s31-cart-coupon-button").parent().addClass("field error");
				$("#s31-cart-coupon-button").after("<div class=\"alert alert-danger pointing label sylius-validation-error-2\">" + actionCodeError +"</div>");

				return false;
			}
		}
		else{
			$("#sylius_cart_promotionCoupon").val("").removeAttr("disabled");
		}

		/*if ($(this).data("remove")) {
			e.preventDefault();

			$.ajax({
				method: 'POST',
				cache: false,
				url: $(this).data("remove"),
				success: function (response) {
					var $payload = $(response);

					processCartSummaryResponse($payload);
				},
				error: function (jqXHR) {
				}
			});
		}*/
	});

	if ($(".s31-thankyou-redirect-timer").length) {
		var counter = 10;
		var interval = setInterval(function() {
			counter--;
			$(".s31-thankyou-redirect-timer").text("0" + counter);
			if (counter == 0) {
				var hostname = window.location.protocol + "//" + window.location.hostname;
				var orderUrl = $("#s31-sendOrderButt").attr("href");
				window.location.replace(hostname + orderUrl);
				clearInterval(interval);
			}
		}, 1000);
	}
});

window.syliusCartActiveRequest = false;

function submitCartForm(form) {
	var href = "/ajax" + form.attr('action');

	if (window.syliusCartActiveRequest) {
		return;
	}

	window.syliusCartActiveRequest = true;

	$.ajax({
		method: 'PATCH',
		data: form.serialize(),
		cache: false,
		url: href,
		success: function (response) {
			var $payload = $(response);
			processCartSummaryResponse($payload);
		},
		error: function (jqXHR) {

		},
		complete: function() {
			window.syliusCartActiveRequest = false;
			window.syliusCartSubmittedBy = null;
			$(document).trigger("sylius.cart.update_complete");
		}
	});
}

var processCartSummaryResponse = function($payload) {
	var error = false;

	if ($('#s31-cart-couponLabel input').is(":checked")) {
		$payload.find("#s31-cart-couponLabel input").attr("checked", "checked");
		$payload.find("#s31-cart-couponForm").css("display", "block");
	}

	if ($payload.find("#s31-cart-coupon-pane").length > 0) {
		$("#s31-cart-coupon-pane").html($payload.find("#s31-cart-coupon-pane").html());
	}

	if ($payload.find(".s31-cart-articles .sylius-validation-error").length > 0) {
		error = true;

		$(".s31-cart-articles .sylius-validation-error").remove();
		if (syliusCartSubmittedBy == "coupon-button") {
			$("#s31-cart-coupon-button").parent().addClass("field error");
			$("#s31-cart-coupon-button").after($payload.find(".s31-cart-articles .sylius-validation-error"));
		} else {
			$payload.find(".s31-cart-articles .sylius-validation-error").each(function (index, element) {
				$("form[name=sylius_cart] .s31-cart-articles").prepend(element);
			});
		}
	}

	if ($payload.find(".s31-cart-articles-freeDelivery").length > 0) {
		if ($(".s31-cart-articles-freeDelivery .s31-cart-articles-freeDeliveryBarDone").length > 0 && $payload.find(".s31-cart-articles-freeDelivery .s31-cart-articles-freeDeliveryBarDone").length > 0) {
			$(".s31-cart-articles-freeDelivery .s31-cart-articles-freeDeliveryText").html($payload.find(".s31-cart-articles-freeDelivery .s31-cart-articles-freeDeliveryText").html());
			$(".s31-cart-articles-freeDelivery .s31-cart-articles-freeDeliveryBarDone").attr("style", $payload.find(".s31-cart-articles-freeDelivery .s31-cart-articles-freeDeliveryBarDone").attr("style"));
			$(".s31-cart-articles-freeDelivery").attr("data-percentage-amount", $payload.find(".s31-cart-articles-freeDelivery").attr("data-percentage-amount"));
		} else {
			$(".s31-cart-articles-freeDelivery").html($payload.find(".s31-cart-articles-freeDelivery").html());
		}
	}

	if ($payload.find(".s31-cart-total").length > 0) {
		$(".s31-cart-total").html($payload.find(".s31-cart-total").html());
		$(".s31-cartHeaderTotalprice").html($payload.find("#sylius-cart-grand-total").html());
		$(".s31-ico-text-headingMobile strong").html($payload.find("#sylius-cart-grand-total").html());
		if ("#s31-vo-delivery-missing") { 
			var voNoVatPrice = $("#sylius-cart-tax-total").attr("data-vo-total") / 100;
			if (voNoVatPrice < 5000) {
				$(".s31-flash-messages-warning").removeClass("d-none");
				var voMissingPrice = 5000 - Math.round(voNoVatPrice);
				result = voMissingPrice.toLocaleString() ;
				$("#s31-vo-delivery-missing").html(result + ' Kč');
			} else {
				$(".s31-flash-messages-warning").addClass("d-none");
			}
		}
	}

	if ($payload.find(".s31-cartTotalQuantity").length > 0) {
		$("#s31-cart-layer .s31-cartTotalQuantity").html($payload.find(".s31-cartTotalQuantity").html());
		$("#cart-button .s31-ico-count").html($payload.find(".s31-cartTotalQuantity").html());
		$(".s31-cartTotalQuantityWord").html($payload.find(".s31-cartTotalQuantityWord").html());
	}
	
	if ($payload.find(".s31-cart-gift-pane").length > 0) {
		$(".s31-cart-gift-pane").html($payload.find(".s31-cart-gift-pane").html());
	}

	if (error == false) {
		$(".s31-cart-articles .sylius-validation-error").remove();
		$(".s31-cart-articles .sylius-validation-error-2").remove();

		$("#sylius-cart-items").html($payload.find("#sylius-cart-items").html());
		$("#sylius-coupon").html($payload.find("#sylius-coupon").html());
		$(".s31-cart-total").html($payload.find(".s31-cart-total").eq(0).html());

		if (typeof selectSizeInSelectGift != 'undefined') {
			selectSizeInSelectGift();
		}
	}

	if ($payload.find(".gtm-cart-push").length > 0) {
		$("#sylius-cart-items").prepend($payload.find(".gtm-cart-push"));
	}

}